import { render, staticRenderFns } from "./true-false.vue?vue&type=template&id=1fe640f6&scoped=true"
import script from "./true-false.vue?vue&type=script&lang=js"
export * from "./true-false.vue?vue&type=script&lang=js"
import style0 from "./true-false.vue?vue&type=style&index=0&id=1fe640f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe640f6",
  null
  
)

export default component.exports